import { Box } from '@chakra-ui/react';
import { Checkbox, Tooltip } from 'ui-components';
import { ContentsApiResponseResultsType } from '~/searchApi';

interface Props {
  content: ContentsApiResponseResultsType;
  isChecked: boolean;
  onSelectChange: (
    checked: boolean,
    content: ContentsApiResponseResultsType,
  ) => void;
  totalSelectedCount: number;
}

export const SelectContent = ({
  content,
  isChecked,
  onSelectChange,
  totalSelectedCount,
}: Props) => {
  return (
    <Box
      position="absolute"
      right={1}
      top={1}
      opacity={1}
      _groupHover={{ opacity: 1 }}
      transition="opacity 0.2s"
    >
      {totalSelectedCount === 20 && !isChecked ? (
        <Tooltip
          label="Selection is limited to 20 items"
          aria-label="tooltip"
          placement="top-start"
        >
          <Checkbox isDisabled />
        </Tooltip>
      ) : (
        <Checkbox
          isChecked={isChecked}
          onChange={(checked) => onSelectChange(checked, content)}
          _hover={{}}
        />
      )}
    </Box>
  );
};
